import React from "react";
import { classNames } from "../utils";

type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

const Container = (props: Props) => {
  return (
    <div
      {...props}
      className={classNames(
        `bg-white p-6 rounded-xl shadow shadow-gray-300 print:p-0 print:shadow-none`,
        props.className ?? ""
      )}
    >
      {props.children}
    </div>
  );
};

export default Container;
